export default function Impressum() {
  return (
    <section className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Impressum</h1>
      <p>
        <strong>Firma:</strong> Future Now UG<br />
        <strong>Geschäftsführer:</strong> Olaf Niggemann<br />
        <strong>Adresse:</strong> Max‑Planck‑Str. 4, 85609 Aschheim, Deutschland<br />
        <strong>E‑Mail:</strong> <a href="mailto:info@future-now.online" className="text-primary-500 hover:underline">info@future-now.online</a>
      </p>
      <p className="mt-4">
        Registergericht: Amtsgericht München<br />
        Registernummer: HRB 123456
      </p>
    </section>
  );
}